<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $tc("add") }} {{ $tc("client", 1) }}
      </div>
      <router-link class="btn-blue" to="clients"
        >{{ $t("clients") }} {{ $tc("list", 1) }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <div class="row">
        <!-- NAME -->
        <div class="col-lg-6 col-xl-4 mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="client_name"
                name="client_name"
                v-validate="'required'"
                v-model="client.client_name"
                placeholder="."
              />
              <label>{{ $t("client_name") }}</label>
            </div>
            <!-- <Tooltip :title="$t('client_name_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('client_name')">{{
              errors.first("client_name")
            }}</span>
          </p>
        </div>
        <!-- DESC -->
        <div class="col-lg-6 col-xl-4 mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="client_description"
                name="client_name"
                v-model="client.client_description"
                placeholder="."
              />
              <label>{{ $t("client_description") }}</label>
            </div>
            <!-- <Tooltip :title="$t('client_description_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>
        <!-- PERSON NAME -->
        <div class="col-lg-6 col-xl-4 mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="client_contact_person_name"
                name="client_contact_person_name"
                v-validate="'alpha_spaces'"
                v-model="client.client_contact_person_name"
                placeholder="."
              />
              <label>{{ $t("client_contact_person_name") }}</label>
            </div>
            <!-- <Tooltip :title="$t('client_contact_person_name_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span
              v-if="submitted && errors.has('client_contact_person_name')"
              >{{ errors.first("client_contact_person_name") }}</span
            >
          </p>
        </div>
        <!-- EMAIl ID -->
        <div class="col-lg-6 col-xl-4 mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="client_contact_person_email_id"
                name="client_contact_person_email_id"
                v-model="client.client_contact_person_email_id"
                v-validate="'email'"
                placeholder="."
              />
              <label>{{ $t("client_contact_person_email_id") }}</label>
            </div>
            <!-- <Tooltip :title="$t('client_contact_person_email_id_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span
              v-if="submitted && errors.has('client_contact_person_email_id')"
              >{{ errors.first("client_contact_person_email_id") }}</span
            >
          </p>
        </div>
        <!-- MOBILE NUMBER -->
        <div class="col-lg-6 col-xl-4 mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material row">
              <div class="col-4">
                <b-dropdown
                  :text="
                    client.country_mob_code ? client.country_mob_code : 'Code'
                  "
                  variant="dropdown-curve"
                  class="w-100 text-center mr-3"
                  placeholder="code"
                  name="countrycode"
                  id="countrycode"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Code"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchCode($event.target.value)"
                      v-on:keydown="onSearchCode($event.target.value)"
                      v-on:search="onSearchCode($event.target.value)"
                      v-model="searchCode"
                    />
                  </div>
                  <b-dropdown-item
                    href="#"
                    v-for="(countrycode, countryIndex) in countryList"
                    :key="countryIndex"
                    v-on:click="onSelectHandler('countrycode', countrycode)"
                    v-if="countrycode.country_mob_code != null"
                    >{{ countrycode.country_mob_code }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
              <div class="col-8 pl-1">
                <input
                  id="client_contact_person_mobile_number"
                  name="client_contact_person_mobile_number"
                  v-model="client.client_contact_person_mobile_number"
                  v-validate="'numeric|min:7'"
                  placeholder="."
                  style="width: 260.76px"
                />
                <label>{{ $t("client_contact_person_mobile_number") }}</label>
              </div>
            </div>
            <!-- <Tooltip
              :title="$t('client_contact_person_mobile_number_tooltip')"
            /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && !client.country_mob_code">{{
              "Country Code is Required."
            }}</span>
            <span>{{ " " }}</span>
            <span
              v-if="
                submitted && errors.has('client_contact_person_mobile_number')
              "
              >{{ errors.first("client_contact_person_mobile_number") }}</span
            >
          </p>
        </div>
        <!-- ADDRESS -->
        <div class="col-lg-6 col-xl-4 mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="client_address"
                name="client_address"
                v-model="client.client_address"
                placeholder="."
              />
              <label>{{ $t("client_address") }}</label>
            </div>
            <!-- <Tooltip :title="$t('client_address_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>
        <div class="col-lg-6 col-xl-4 mb-3" v-if="!isEmpire">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="client_contact_person_email_id"
                name="client_contact_person_email_id"
                v-model="client.client_pan_no"
                placeholder="."
              />
              <label>PAN Number</label>
            </div>
            <!-- <Tooltip :title="`PAN No.`" /> -->
          </div>
          <p class="error_message"></p>
        </div>
        <div class="col-lg-6 col-xl-4 mb-3" v-if="isEmpire">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="client_cr_no"
                name="client_cr_no"
                v-model="client.client_cr_no"
                placeholder="."
              />
              <label>CR Number</label>
            </div>
            <!-- <Tooltip :title="`PAN No.`" /> -->
          </div>
          <p class="error_message"></p>
        </div>
        <div class="col-lg-6 col-xl-4 mb-3" v-if="isEmpire">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="client_vat_no"
                name="client_vat_no"
                v-model="client.client_vat_no"
                placeholder="."
              />
              <label>VAT Number</label>
            </div>
            <!-- <Tooltip :title="`PAN No.`" /> -->
          </div>
          <p class="error_message"></p>
        </div>
        <div class="col-lg-6 col-xl-4 mb-3">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <!-- <label class="ios-switch"> -->
            <b-form-checkbox
              type="checkbox"
              class="j-checkbox"
              v-model="client.client_is_active"
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
          </div>
        </div>
      </div>

      <section class="my-3 w-100 px-3 distributor-section-new">
        <div
          class="section-title d-flex justify-content-between section-border section-border"
          v-b-toggle.transalations
          style="padding: 6px; align-items: center"
        >
          <span class="fs">
            {{ "Translations" }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="transalations"
          class="mt-2 translationContainer"
          v-model="sectionCollapse.transalations"
        >
          <div class="bn-tabs-nav">
            <button
              v-for="(content, contentIndex) in langContent"
              :key="contentIndex"
              :class="[
                'btn-tab-title ',
                { active: contentIndex == activeClass },
              ]"
              @click.prevent.stop="onChangeTabHandler($event, contentIndex)"
            >
              <strong>
                <span
                  :class="
                    content.langauge.toLowerCase() !== 'english'
                      ? notempty[contentIndex]
                        ? ''
                        : 'text-danger'
                      : ''
                  "
                  >{{ content.langauge }}</span
                >
              </strong>
            </button>
          </div>

          <div class="bn-tabs-content p-3">
            <div
              v-for="(content, contentIndex) in langContent"
              :key="contentIndex"
            >
              <div v-if="contentIndex === activeClass">
                <div class="row">
                  <div class="col-md-4">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          v-model="content.client_name"
                          placeholder="."
                          name="client_name"
                          id="client_name"
                          maxlength="200"
                          @input="
                            onChangeTranslationInput(
                              $event,
                              content,
                              'client_name',
                              contentIndex
                            )
                          "
                        />
                        <label :class="content.client_name ? 'shift-up' : ''"
                          >Client Name</label
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          v-model="content.client_description"
                          placeholder="."
                          name="client_description"
                          id="client_description"
                          maxlength="200"
                          @input="
                            onChangeTranslationInput(
                              $event,
                              content,
                              'client_description',
                              contentIndex
                            )
                          "
                        />
                        <label
                          :class="content.client_description ? 'shift-up' : ''"
                          >Client description</label
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          v-model="content.client_address"
                          placeholder="."
                          name="client_address"
                          id="client_address"
                          maxlength="200"
                          @input="
                            onChangeTranslationInput(
                              $event,
                              content,
                              'client_address',
                              contentIndex
                            )
                          "
                        />
                        <label :class="content.client_address ? 'shift-up' : ''"
                          >Client Address</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <div class="text-center">
        <button @click.prevent.stop="addClient(false)" class="btn-blue">
          {{ $t("save") }}
        </button>
        <button @click.prevent.stop="addClient(true)" class="btn-blue">
          {{ $t("saveaddmore") }}
        </button>
        <button @click.prevent.stop="resetClient()" class="btn-black">
          {{ $t("reset") }}
        </button>
        <b-button
          class="btn-outline-grey"
          variant="default"
          to="/master/clients"
          >{{ $t("cancel") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import ClientService from "@/services/ClientService";
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";
import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

export default {
  data() {
    return {
      submitted: false,
      sectionCollapse: {
        transalations: true,
        cinemadetails: true,
      },
      langContent: [],
      Languages: [],
      ContentLanguages: [],
      activeClass: 0,
      notempty: [false, false, false, false, false, false],
      ActiveLanguages: [],
      client: {
        client_name: null,
        client_description: null,
        client_contact_person_name: null,
        client_contact_person_email_id: null,
        client_contact_person_mobile_number: null,
        client_pan_no: null,
        client_cr_no: null,
        client_vat_no: null,
        client_address: null,
        client_is_active: true,
        country_mob_code: "",
        client_translation_data: null,
      },
      searchCode: "",
      CodeListCopy: [],
      countryList: [],
      SelectedCountryCode: "",
    };
  },
  beforeMount() {
    this.getCountryList();
    this.getActiveLanguages();
    this.getContentLanguage();
  },
  computed: {
    isEmpire() {
      return this.authorizeClient(CLIENT_NAMES_OBJ.empire) || false;
    },
  },
  methods: {
    CheckEmptyContent: function (content, langIndex) {
      if (
        content.client_name &&
        content.client_address &&
        content.client_description
      ) {
        this.notempty[langIndex] = true;
      } else {
        this.notempty[langIndex] = false;
      }
    },
    onChangeInput(event, item) {
      let index =
        this.langContent.findIndex(
          (x) => x.langauge.toLowerCase() == "english"
        ) || 0;
      if (item.fieldname == "client_name") {
        this.langContent[index].client_name = event.target.value;
      } else if (item.fieldname == "client_address") {
        this.langContent[index].client_address = event.target.value;
      } else if (item.fieldname == "client_description") {
        this.langContent[index].client_description = event.target.value;
      }
    },
    onChangeTranslationInput(event, content, item, contentIndex) {
      if (content.langauge.toLowerCase() == "english") {
        this.client[item] = event.target.value;
      }
      this.CheckEmptyContent(content, contentIndex);
    },
    onChangeTabHandler: function (event, index) {
      this.activeClass = index;
    },
    getContentLanguage: function () {
      MovieService.GetMovieContentLanguages()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.ContentLanguages.length > 0) {
              this.ContentLanguages = data.ContentLanguages;
            }
          } else {
            console.log("data.message :", data.message);
          }
          return;
        })
        .then(() => {
          this.makeLangContainers();
        })
        .catch((error) => {});
    },
    makeLangContainers: function () {
      this.ContentLanguages.map((x) => {
        let Obj = {
          ...x,
          client_name: "",
          client_description: "",
          client_address: "",
        };
        this.langContent.push(Obj);
        console.log("this.langContent", this.langContent);
      });
    },
    getActiveLanguages() {
      let body = {
        tableName: "ms_language",
        lang_is_active: "Y",
      };
      MasterService.GetActiveList(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.ActiveLanguages = data.Records;
            }
          } else
            this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    onSearchCode() {
      if (this.searchCode && this.searchCode.length > 0) {
        this.countryList = this.CodeListCopy.filter((x) => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.countryList = this.CodeListCopy;
      }
    },
    onSelectHandler(type, value, index) {
      if (type == "countrycode") {
        this.client.country_mob_code = value.country_mob_code;
        this.SelectedCountryCode = value.country_mob_code;
      }
    },
    getCountryList: function () {
      this.stateList = [];
      this.countryList = [];
      this.CodeListCopy = [];
      this.cityList = [];
      let payload = {
        tableName: "ms_countries",
        country_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.countryList = data.Records;
            this.CodeListCopy = data.Records;
          } else {
            console.log("show error1 :", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    resetClient: function () {
      this.client = {
        client_name: null,
        client_description: null,
        client_contact_person_name: null,
        client_contact_person_email_id: null,
        client_contact_person_mobile_number: null,
        client_pan_no: null,
        client_cr_no: null,
        client_vat_no: null,
        client_address: null,
        client_is_active: true,
        country_mob_code: "",
        client_translation_data: null,
      };
      this.langContent.map((x) => {
        x.client_name = "";
        x.client_description = "";
        x.client_address = "";
      });
    },
    addClient(flag) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (!this.client.country_mob_code) {
            return;
          }
          let payload = {
            ...this.client,
            client_translation_data: this.langContent.length
              ? this.langContent
              : null,
          };
          ClientService.CreatAClient(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.$toasted.show(data.message);
                if (flag) {
                  this.resetClient();
                } else {
                  this.$router.push({
                    path: "/master/clients",
                  });
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    },
  },
};
</script>

    



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ClientComponent/addClient.vue